<template>
  <div>
    <div class="section-header">
      <h1>
        Assessments
      </h1>
    </div>
    <div class="card card--white" v-if="!loading && !assessments.length">
      <div class="section align-center">
        You have not taken any Assessments.  Contact your coach if you’d like to take one.
      </div>
    </div>
    <div class="row flex-wrap">
      <div 
        class="card card--transparent small-top img-background row space-between" 
        v-for="(assessment, i) in assessments" 
        :key="assessment.uuid"
        @click="$router.push('/c/assessments/' + assessment.uuid)">
        <div>
          <h2>{{assessment.assessment}}</h2>
          <div class="small-info">{{assessment.createdAt}}</div>
          <!-- {{assessment.created_at}} -->
        </div>
        <i 
          class="material-icons clickable" 
          @click="$router.push('/c/assessments')">arrow_forward</i>

      </div>
    </div>
    <!-- {{assessments}} -->
  </div>
</template>

<script>
import store from "@/services/api/store";
import moment from "moment";

export default {
  data() {
    return {
      assessments: [],
      loading: true
    }
  },
  created() {
    store.findAll("ClientAssessments", {limit: 500}, {force: true})
    .then(r => {
      r.forEach(assessment => {
        assessment.createdAt = moment(assessment.created_at).format('ll');
      });
      this.assessments = r;
    }).finally(() => {
      this.loading = false;
    })
  },
}
</script>

<style lang="less" scoped>
.img-background {
  background-repeat: no-repeat;
  width: 48%;
  min-height: 80px;
  color: white;
  cursor: pointer;
  @media (max-width: 600px) {
    width: 100%;
  }
  .small-info {
    font-size: 12px;
  }

  h2 {
    text-transform: none;
  }
};

</style>
